'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CareerCategory;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _Icon = require('../../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'career-category';

function CareerCategory(_ref) {
  var _ref$category = _ref.category,
      href = _ref$category.href,
      icon = _ref$category.icon,
      iconAlt = _ref$category.iconAlt,
      jobs = _ref$category.jobs,
      label = _ref$category.label;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      _reactRouter.Link,
      { to: href },
      _react2.default.createElement(
        'div',
        { className: CLASS_NAME + '-icon' },
        _react2.default.createElement(_Icon2.default, { iconName: icon, color: '#fff', height: 42 })
      ),
      _react2.default.createElement(
        'div',
        { className: CLASS_NAME + '-title' },
        label
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/CareerCategories/CareerCategory.jsx
// module id = 1121
// module chunks = 0